import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@shared/api/client';
import { brand } from './tokens';

export interface Branding { clubName: string; appName: string; primary: string; secondary: string; logoUrl: string | null; loaded: boolean }

const STATIC = { primary: brand.primary, secondary: brand.secondary, logoUrl: null };
const HEX = /^#[0-9a-f]{6}$/i;
const SAFE_LOGO = /^(https:\/\/|\/)/;

interface TenantConfigDto { clubName: string; appName: string | null; primaryColor: string; secondaryColor: string; logoUrl: string | null }

export function useBranding(): Branding {
  const q = useQuery({
    queryKey: ['tenant-config', 'branding'],
    queryFn: async () => (await apiClient.get<TenantConfigDto>('/tenant/config')).data,
    staleTime: 60_000,
  });
  if (!q.data) {
    // In caricamento il nome e' vuoto (niente flash); in errore 'Backoffice'.
    const name = q.isError ? 'Backoffice' : '';
    return { ...STATIC, clubName: name, appName: name, loaded: false };
  }
  const d = q.data;
  return {
    clubName: d.clubName,
    appName: d.appName ?? d.clubName,
    primary: HEX.test(d.primaryColor) ? d.primaryColor : STATIC.primary,
    secondary: HEX.test(d.secondaryColor) ? d.secondaryColor : STATIC.secondary,
    logoUrl: d.logoUrl && SAFE_LOGO.test(d.logoUrl) ? d.logoUrl : null,
    loaded: true,
  };
}
